import { InjectionToken } from '@angular/core';

import { environment } from '../../environment/environment';

export const ENV = new InjectionToken<typeof environment>('env');
